import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Tilbage',
      changePassword: 'Skift',
      copiedVaultId: 'Kopieret!',
      copyVaultID: 'Kopiér Vault-ID',
      create: 'Opret',
      next: 'Næste',
      notSure: 'Jeg er ikke sikker.',
      signUp: 'Tilmeld',
      submit: 'Indsend',
      updatePassword: 'Opdater adgangskode',
    },
    Errors: {
      createReportFailed: 'Oprettelse af rapport mislykket.',
    },
    ReportStatus: {
      CLOSED: 'Lukket',
      INVESTIGATING: 'Undersøger',
      NEW: 'Indsendt',
      READ: 'Læs',
    },
    general: {
      navbar: {
        caseSettings: 'Sag indstillinger',
        changePassword: 'Skift adgangskode',
        logOut: 'Log ud',
        notifications: 'Notifikationer',
        notificationsDrawer: {
          appFileScanFailed: 'En fil har fejlet sikkerhedstjek',
          appReportMatch: 'Din GoTogether optegnelse er blevet matchet',
          appReportReassigned: 'En ny sagsbehandler er blevet tildelt',
          case: 'Sag',
          caseAssigned: 'Sag tildelt dig',
          caseImporterJobCompleted: {
            PartialSuccess: 'Din sag import blev fuldført med fejl',
            failure: 'Din sag import mislykkedes',
            success: 'Din sag import blev gennemført med succes',
          },
          caseLinked: 'Sag linket',
          caseTeamInvite: 'Tilføjet til sag',
          caseUnlinked: 'Sag afkoblet',
          dataSanitisation: 'Rapport detaljer opdateret',
          emptyDescription: 'Tjek tilbage senere for nye notifikationer',
          emptyTitle: 'Du er helt opdateret',
          importId: 'Import ID:',
          learnMore: 'Lær mere',
          markAllAsRead: 'Marker alle som læst',
          newMessage: 'Ny besked',
          newReport: 'Ny rapport modtaget',
          permissionRemoved: 'Fjernet fra sag',
          postSSubmissionFile: 'Bevisfil(er) tilføjet',
          report: 'Rapport',
          reportAssigned: 'Rapport tildelt dig',
          reportStatusChange: 'Rapportstatus ændret',
          reporterAnonymised: 'Dine detaljer er blevet anonymiseret',
          reporterReportSubmitted: {
            subtitle: 'Vi anbefaler at gemme en kopi af din rapport',
            title: 'Rapport indsendt',
          },
          mitigationPlanReminder: 'Godkendelse af afhjælpningsplan påkrævet',
          staleCase: 'Ubehandlede sag',
        },
        privacyStatement: 'Privatlivserklæring',
        reporter: {
          myReports: 'Mine rapporter',
        },
        settings: 'Indstillinger',
        technicalSupport: 'Teknisk support',
        title: 'Konto',
      },
      time: {
        day: 'Dag',
        days: 'Dage',
        hour: 'Time',
        hours: 'Timer',
        minute: 'Minut',
        minutes: 'Minutter',
        second: 'Sekund',
        seconds: 'Sekunder',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonym',
        autoTranslate: 'Automatisk oversættelse er slået fra som standard.',
        backToMessages: 'Tilbage til beskeder',
        caseSettings: 'Sagsindstillinger.',
        changeInProfile:
          'Hvis du ønsker at ændre denne indstilling, kan du gøre det i din profils ',
        deletedByMessage: 'Slettet af {{author}}',
        deletedMessageLabel: 'Denne besked blev slettet',
        description:
          'Når automatisk oversættelse er slået til, vil alle rapportbeskeder blive\n          automatisk oversat ved hjælp af AI baseret på standardsproget,\n          der er valgt i din browser.',
        descriptionSecondHalf:
          'Den oprindelige version af alle beskeder bevares altid og kan findes i chatten.',
        messagePlaceholder: 'Begynd at skrive...',
        messageSettings: 'Indstillinger for beskeder.',
        originalMessages: 'Original',
        showMoreBanner: 'Lær mere om automatiske oversættelser',
        titlev2: 'Læs alle beskeder på dit foretrukne sprog.',
        translatedMessageLabel: 'Oversat besked',
        translatedMessages: 'Oversat',
        understood: 'Forstået',
      },
      Country: {
        description: 'I hvilket land er du baseret?',
        header: 'I hvilket land er du baseret?',
        noOptions: 'Ingen lande fundet',
        other: 'Andet',
        placeholder: 'Søg efter et land...',
      },
      CreatePublicReport: {
        createReport: 'Opret en rapport',
        helpPage: 'Gå til vores hjælpeside',
        loginToOpr: 'Log ind for at følge rapporter',
        or: 'eller',
        passwordPlaceholder: 'Indtast adgangskode',
        phoneNumberLoginFailed:
          'Login mislykket, telefonnummer/pinkode forkert',
        phoneNumberPlaceholder: 'Indtast dit telefonnummer',
        phoneNumberTooltip:
          'Indtast det telefonnummer, du brugte til at kontakte VaultTalk',
        pinPlaceholder: 'Indtast pinkode',
        reportIntroductionParagraph1:
          'Når du rapporterer en hændelse, vil du blive stillet et par spørgsmål, som skal hjælpe dig med at dokumentere din oplevelse.',
        reportIntroductionParagraph2:
          'Før du sender, har du mulighed for at være anonym for at beskytte dit privatliv.',
        reportIntroductionParagraph3:
          'Når du har indsendt, kan du til enhver tid logge ind for at se, hvordan processen med din rapport skrider frem, og tale med en sagsbehandler.',
        reportIssue: 'Rapportér et problem',
        usernameLoginFailed:
          'Login mislykkedes, brugernavn/adgangskode forkert',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'Forhold til virksomheden er påkrævet',
            reportedCategoryRequired: 'Den angivne kategori er nødvendig',
          },
        },
        vaultId: 'Vault-ID',
        vaultIdPlaceholder: 'Indtast din e-mail eller dit Vault-ID',
        vaultIdTooltip:
          "For anonyme rapporter er Vault-ID'et alfanumerisk. Hvis rapporten ikke var anonym, er Vault-ID'et din e-mailadresse",
        vaultTalk: 'VaultTalk',
        yourPassword: 'Din adgangskode',
        yourPhoneNumber: 'Dit telefonnummer',
        yourPin: 'Din 6-cifrede pinkode',
        yourVaultId: 'Dit Vault-ID',
      },
      CustomHeader: {
        companyLogo: '{{company}}-logo',
        openReporting: 'Åben rapportering',
        userSettings: 'Brugerindstillinger',
      },
      Date: {
        approximateDescription:
          'Kan du omtrent huske den dato, hvor hændelsen fandt sted?',
        approximatePlaceholder:
          'Eksempel: For 6 måneder siden / sidste år / sidste november',
        cancel: 'annuller',
        clear: 'ryd',
        description: 'Kan du huske, hvilken dato hændelsen fandt sted?',
        header: 'Hvilken dag fandt det sted?',
        ok: 'ok',
        placeholder: 'Eksempel: 21. juni 2020',
      },
      Description: {
        whatHappened: 'Hvad skete der?',
        whatHappenedPlaceholder: 'Brug dine egne ord...',
        whatHappenedText: 'Beskriv med dine egne ord, hvad der skete',
      },
      Details: {
        disclaimer:
          'Disse oplysninger vil blive offentliggjort sammen med din rapport. Hvis du ønsker at være anonym, skal du sørge for, at de ikke indeholder identificerende oplysninger.',
        emailPlaceholder: 'E-mail (valgfrit)',
        fullNamePlaceholder: 'Fuldt navn (valgfrit)',
        header: 'Dine oplysninger',
        nonAnonSubtitle:
          'Angiv enten dit navn eller en e-mailadresse. Hvis du ønsker at modtage notifikationer om denne rapport, tilføj en passende e-mailadresse nedenfor.',
        nonOptionalEmailPlaceholder: 'E-mail',
        nonOptionalFullNamePlaceholder: 'Fulde Navn',
        subtitle:
          'Hvis du ønsker at modtage notifikationer om denne rapport, skal du tilføje en e-mailadresse nedenfor.',
      },
      Emotion: {
        description: 'Hvordan fik det dig til at føle? Hvad var påvirkningen?',
        header: 'Hvad var påvirkningen?',
        placeholder: 'Begynd at skrive...',
      },
      Evidence: {
        addedHeading: 'Tilføjet',
        deletedMessage: 'blev slettet',
        deletedStatus: 'Slettet',
        failedToOpenFileMessage: 'Kunne ikke åbne filen. Prøv igen',
        fileStatuses: {
          infectedUpload: 'Markeret af sikkerhedstjek',
          passedUpload: 'Bestået sikkerhedstjek',
          pendingUpload: 'Sikkerhedstjek i gang',
          readyForDownload: 'Klar til download',
        },
        mobileErrorMessage: 'Markerede filer: Giv din sagsbehandler besked',
        nameHeading: 'Navn',
        statusHeading: 'Status',
        tableTitle: 'Bevismateriale',
        webErrorMessage:
          'Markerede filer: Hvis din eller dine sager er blevet markeret, bedes du give besked til sagsbehandleren',
      },
      FileUpload: {
        addFiles: 'Tilføj filer',
        addMoreFiles: 'Tilføj flere filer',
        confirm: 'Bekræft',
        description:
          'Hvis du tilføjer filer som bevismateriale, kan det hjælpe din sagsbehandler med at finde en løsning. Overvej filindholdet (herunder filmetadata), hvis du ønsker at forblive anonym, og respekter andre personers rettigheder og gældende love.',
        dragDrop: 'Slip filer her eller',
        errorMessage:
          'Fil(er) mislykket på grund af en netværksfejl. Klik nedenfor for at sende en besked til din sagsbehandler om at få hjælp',
        fileLimit: 'Grænse for hver fils størrelse: 100 MB',
        fileUploadLimitText: 'Du kan kun uploade 10 filer',
        header: 'Tilføj bevismateriale',
        helpArticle: 'hjælp-artikel',
        highlighted: 'gennemse filer',
        information: 'Understøttede filtyper',
        moreInformation:
          'Du kan finde mere information her <a>hjælp-artikel</a>',
        postSubmissionErrorMessage:
          "Vi kunne ikke uploade dine filer på grund af en systemfejl. Vælg venligst 'bekræft' igen.",
        tooltipAudio: 'Lyd:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Dokumenter:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Billeder:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Tekst:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Filen er for stor',
          invalidFileType: 'Ikke-understøttet filtype: {{extension}}',
          systemError: 'Systemfejl',
          tooManyFiles: 'Det maksimale antal filer er {{maxFiles}}',
        },
        uploadFiles: 'Upload filer',
      },
      Loading: {
        loading: 'Vent, mens vi sender din rapport til en sagsbehandler...',
        postSubmissionLoading: 'Vent, mens vi sender dine filer...',
      },
      Location: {
        description: 'Hvor skete det?',
        header: 'Hvor skete det?',
        placeholder: 'Eksempel: På kontoret',
      },
      MessageListBox: {
        messageCaseManager: 'Besked til sagsbehandler',
        report: 'Rapport {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Oversættelse deaktiveret',
        enableTranslationLabelEnabled: 'Oversættelse aktiveret',
        enableTranslationsDescription:
          'Aktivér automatisk oversættelse, og læs alle rapportbeskeder på dit foretrukne sprog. Det oversatte sprog er baseret på det sprog, der er valgt på din enhed.',
        enableTranslationsHeader:
          'Aktivér automatisk oversættelse af rapportbeskeder',
        enableTranslationsSubDescriptionv2:
          'Du kan skifte mellem det oversatte og det originale sprog i hver chat.',
        updateTranslationFailed: 'Opdatering af oversættelse mislykket',
        updateTranslationSuccess: 'Oversættelsesindstilling opdateret',
      },
      Password: {
        changePasswordHeader: 'Skift',
        createNewPassword: 'Opret venligst en ny adgangskode',
        createPasswordHeader: 'Din adgangskode',
        currentPasswordPlaceholder: 'Indtast nuværende adgangskode',
        description:
          'En gyldig adgangskode skal være mindst 9 tegn lang og indeholde et stort bogstav og et tal',
        enterCurrentPassword: 'Indtast din nuværende adgangskode',
        forgottenPasswordInstructions:
          'Indtast dit alfanumeriske Vault ID (ikke din e-mailadresse) og e-mailadresse for at nulstille din adgangskode.',
        newDescription:
          'Opret en stærk adgangskode for at holde din konto sikker. Begynd at skrive for at se retningslinjerne nedenfor.',
        passwordPlaceholder: 'Opret en adgangskode',
        passwordResetRequestedDescription:
          'Hvis dit Vault ID findes i vores system, vil du modtage en e-mail med instruktioner til at nulstille din adgangskode.',
        passwordResetRequestedHeader: 'Link til nulstilling af kodeord anmodet',
        reenterPlaceholder: 'Indtast adgangskoden igen',
        subtitle:
          'Opret en adgangskode til at indsende denne rapport og få adgang til den i fremtiden',
        yourVaultId: 'Dit Vault ID',
        yourVaultIdPlaceholder: 'Indtast dit Vault ID (f.eks. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Rapporterer du en bestemt person eller flere personer? Kan du navngive eller beskrive dem?',
        header: 'Involverede personer',
        placeholder:
          'Begynd at skrive, og brug et komma for at tilføje flere navne eller beskrivelser',
      },
      PoweredByVault: 'Leveret af {{company}}',
      PrivacyStatement: 'Produktets fortrolighedserklæring',
      PublicMessageList: {
        myMessages: 'Mine beskeder',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader:
          'Bevismateriale tilføjet til eksisterende rapport',
        backToReportId: 'Tilbage til rapport-ID: {{reportId}}',
        description:
          'Hvis du tilføjer filer som bevismateriale, kan det hjælpe din sagsbehandler med at finde en løsning. Overvej filindholdet (herunder filmetadata), hvis du ønsker at forblive anonym, og respekter andre personers rettigheder og gældende love. Du kan finde mere information her <a>hjælp-artikel</a>',
        header: 'Tilføj yderligere beviser til rapporten',
        vaultTalkOpenCaseHeader: 'Tilføj beviser til din rapport',
      },
      PublicReport: {
        anonymous: 'Anonym',
        backToReports: 'Tilbage til rapporter',
        skipped: 'Sprunget over',
      },
      PublicReportCard: {
        addEvidence: 'Tilføj yderligere beviser',
        messageCaseManager: 'Besked til sagsbehandler',
        reportId: 'Rapport-ID:',
        submitted: 'Indsendt',
        vaultTalkClosedCaseCTA: 'Se bevismateriale',
        vaultTalkOpenCaseCTA: 'Tilføj bevismateriale',
        viewAdditionalEvidence: 'Se yderligere beviser',
        viewReport: 'Se rapport',
      },
      PublicReportsList: {
        reportingSystem: 'Rapporteringssystem',
      },
      Question: {
        placeholder: 'Begynd at skrive...',
        question: 'Giv flere oplysninger',
        questionText:
          'Del din bekymring, information eller forespørgsel med os',
      },
      Relationship: {
        header: 'Din relation til organisationen',
        tellUsAbout: 'Fortæl os om din forbindelse til organisationen.',
      },
      ResponsiveNavMenu: {
        messages: 'Mine beskeder',
        reports: 'Mine rapporter',
      },
      Site: {
        description: 'På hvilken lokation er du baseret?',
        header: 'På hvilken lokation er du baseret?',
        noOptions: 'Ingen lokationer fundet',
        other: 'Andet',
        placeholder: 'Søg efter en lokation...',
      },
      SpamPuzzle: {
        dialog: 'For at fortsætte skal du løse denne opgave',
      },
      SubmissionTypes: {
        reportIssue: 'Vælg en kategori',
        whatType: 'Vælg den kategori, der bedst beskriver din rapport',
      },
      SubmitSuccess: {
        category: '<bold>Kategori:</bold> {{category}}',
        country: '<bold>Land:</bold> {{country}}',
        dateSubmitted: '<bold>Dato for indsendelse:</bold> {{date}}',
        recordYourVaultID: 'Husk disse oplysninger til at logge ind',
        successInformation: 'Mere information',
        successMessage:
          'Din rapport er blevet indsendt og er klar til gennemgang. Eventuelle vedhæftede filer, der kræver opmærksomhed, vil blive markeret ved indlogning. Log ind nedenfor for at se rapportopdateringer og sende en besked til din sagsbehandler.',
        successSanitationMessage:
          'Gem en kopi til dine poster, og hold dit Vault-ID sikkert - du får brug for det for at få adgang til opdateringer og beskede din sagsgestor.',
        successSanitationTagline: 'Din rapport blev indsendt og sikkert gemt.',
        successThankYou: 'Tak for din rapport!',
        viewReport: 'Se rapport',
      },
      Time: {
        approximateDescription:
          'Kan du omtrent huske det tidspunkt, hvor hændelsen fandt sted?',
        approximatePlaceholder: 'Eksempel: om morgenen, om eftermiddagen',
        description: 'Kan du huske det tidspunkt, hvor hændelsen fandt sted?',
        header: 'Hvornår skete det?',
        invalidTime: 'Tidsformatet skal være TT:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Skift adgangskode',
        closeDialog: 'Luk dialogvindue',
        logout: 'Log ud',
        messageSettings: 'Indstillinger for beskeder',
        userSettings: 'Brugerindstillinger',
      },
      Witnesses: {
        description:
          'Fortalte du det til andre, eller var der nogen, der så, hvad der skete?',
        header: 'Nogen vidner?',
        placeholder: 'Begynd at skrive...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Send besked',
        title: 'Besked Sag Manager',
        translationHeader: 'Lær mere om auto oversættelser',
      },
      ReportCard: {
        addEvidence: 'Tilføj bevis',
        submissionModeVia: 'via {{indsendelsesmetode}}',
        viewEvidence: 'Se bevis',
      },
      ReportList: {
        yourReports: 'Dine rapporter',
      },
      ReportingActivate: {
        buttonText: 'Fortsæt',
        description:
          'Hvis din organisation har registreret dig for en konto, sender vi dig en email med instruktioner for at fuldføre opsætningen.',
        emailInput: 'E-mail',
        header: 'Indtast din arbejdsmail',
        successAccount:
          'Hvis din organisation har registreret dig til en konto, sender vi dig en e-mail med instruktioner til at fuldføre opsætningen.',
        successEmail:
          'Hvis du ikke straks kan se det, vent venligst et par minutter og opdater din email indbakke.',
        successHeading: 'Tak',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Tilføj bevis til din rapport',
        descriptionText:
          'At tilføje filer som bevis kan hjælpe med at støtte effektiviteten af løsningen af din sagshåndterer. Overvej venligst filindholdet (inklusive filmetadata) hvis du ønsker at forblive anonym, og respekter andres rettigheder og gældende love. For mere info, se venligst denne <a>hjælpeartikel</a>',
        emptyMessage: 'Ingen yderligere beviser uploadet',
      },
      ReportingChangePassword: {
        back: 'Tilbage',
        description:
          'Opret en stærk adgangskode for at holde din konto sikker. Begynd at skrive for at se retningslinjer nedenfor.',
        errorToast: 'Kan ikke oprette adgangskode, ugyldig token.',
        header: 'Skift adgangskode',
        incorrectCurrentPassword:
          'Den nuværende adgangskode er forkert. Tjek den og prøv igen.',
        invalidToken: 'Ugyldig token',
        passwordUpdated: 'Adgangskode opdateret',
        passwordUpdatedDescription:
          'Dit kodeord er blevet opdateret med succes. Tak for at tage dette skridt for at holde dine data sikre!',
        passwordUsedBefore: 'Genbrug af kodeord er ikke tilladt',
        passwordUsedBeforeDescription:
          'For din sikkerhed kan du ikke genbruge nogen af dine sidste seks adgangskoder. Vælg venligst en ny, unik adgangskode for at holde din konto sikker og prøv igen.',
        toastDescription:
          'Dit kodeord er blevet opdateret med succes. Tak for at tage dette skridt for at holde dine data sikre!',
        toastMessage: 'Adgangskode opdateret',
        updatePasswordCTA: 'Opdater adgangskode',
      },
      ReportingConnect: {
        cancelButton: 'Annuller',
        connectButton: 'Opret forbindelse',
        disclaimer:
          'At forbinde din Slack-konto med din Vault-konto sikrer en sikker og privat forbindelse.<br /><br />Ved at forbinde kan du rapportere uhensigtsmæssig opførsel eller stille et spørgsmål direkte inden for Slack. Du vil altid have mulighed for at rapportere anonymt efter tilslutning. Dit privatliv og din sikkerhed er vores højeste prioriteter.',
        heading:
          ' Vault Platform anmoder om tilladelse til at få adgang til din {{organisationName}} Slack-konto ',
        listHeading: 'Hvad vil Vault være i stand til at gøre?',
        permissionIdentity: {
          extraInfo: 'Vault får mulighed for at se din Slack-brugers identitet',
          heading: 'Se oplysninger om en brugers identitet',
        },
        permissionNotifications: {
          extraInfo:
            'Vault vil være i stand til at sende beskeder til din Slack-konto om eventuelle opdateringer af en indsendt rapport eller et spørgsmål',
          heading: 'Send dig notifikationer',
        },
        permissionOverview: {
          extraInfo:
            'Vault vil vise en oversigt over alle indsendelser på hjemmesiden',
          heading: 'Oversigt over indsendelser',
        },
        permissionSubmitReport: {
          extraInfo:
            'Dette vil give Vault tilladelse til at indsende en rapport eller stille et spørgsmål direkte til din organisation fra Slack',
          heading: 'Indsend en rapport eller et spørgsmål på dine vegne',
        },
        successfulConnectionDescription:
          'Din Vault-konto og Slack-konto er nu forbundet. Du kan nu lukke denne fane og vende tilbage til Slack.',
        successfulConnectionHeading: 'Forbindelsen er oprettet med succes',
        unsuccessfulConnectionDescription:
          'Noget gik galt. Luk venligst denne fane og vend tilbage til Slack for at prøve igen.',
        unsuccessfulConnectionHeading: 'Forbindelse mislykkedes',
      },
      ReportingForgotPassword: {
        description:
          'Indtast den e-mailadresse, der er forbundet med din konto, og vi sender dig et link til at nulstille din adgangskode.',
        heading: 'Glemt adgangskode',
        invalidTokenError: 'Kan ikke oprette adgangskode, ugyldig token.',
        passwordReuseError: 'Genbrug af adgangskode er ikke tilladt',
        passwordReuseErrorDescription:
          'For din sikkerhed kan du ikke genbruge nogen af dine sidste seks adgangskoder. Vælg venligst en ny, unik adgangskode for at holde din konto sikker og prøv igen.',
        sendLink: 'Send nulstillingslink',
        sendLinkFailure: 'Noget gik galt',
        sendLinkFailureDescription:
          'Gå tilbage til <a>Reporter Hub</a> og prøv igen. Hvis problemet fortsætter, kontakt os på <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Link til nulstilling af adgangskode sendt',
        sendLinkSuccessDescription:
          'Vi har sendt et link til nulstilling af adgangskode til {{email}}',
        updatePasswordSuccess: 'Adgangskode opdateret',
        updatePasswordSuccessDescription:
          'Din adgangskode er blevet opdateret med succes. Tak for at tage dette skridt for at holde dine data sikre!',
      },
      ReportingLogin: {
        accountFrozen: 'Konto er frosset',
        accountLocked:
          'Login er blevet forsøgt for mange gange forkert. Kontoen er låst i op til 1 time. Det er ikke muligt at nulstille adgangskoden i denne periode.',
        accountLockedPermanently:
          'Din konto er blevet låst. Brug nulstilling af adgangskode for at få adgang igen, eller kontakt din systemadministrator for yderligere hjælp.',
        createAccountCTA: 'Registrer for en konto',
        currentPassword: 'Nuværende adgangskode',
        emailLabel: 'Din Email',
        forgotPassword: 'Glemt din adgangskode?',
        loginButton: 'Login',
        newPasswordPlaceholder: 'Ny adgangskode',
        passwordFailMessage:
          'Gå tilbage til Vault-appen i Slack, og prøv igen. Hvis problemet fortsætter, kan du kontakte os på techsupport@vaultplatform.com',
        passwordFailTitle: 'Noget gik galt',
        passwordLabel: 'Dit Rassword',
        passwordPlaceholder: 'Indtast dit kodeord',
        passwordResetRequired: 'Nulstilling af adgangskode påkrævet',
        passwordSuccessfullySetMessage:
          'Gå tilbage til Vault-appen i Slack, og godkend med din nye adgangskode for at fortsætte, hvor du slap.',
        passwordSuccessfullySetTitle: 'Adgangskode indstillet',
        reenterPlaceholder: 'Indtast adgangskode igen',
        title: 'Reporter Hub',
        tooltip:
          'Hvis du aldrig har indstillet en adgangskode til Vault-appen endnu, følg her for at komme i gang. Hvis du har glemt din adgangskode, skal du bruge linket "Glemt adgangskode" nedenfor.',
        usernameLoginFailed:
          'Login mislykkedes, brugernavn eller adgangskode forkert',
      },
      ReportingReset: {
        failureDescription:
          'Gå tilbage til Vault App i Slack og prøv igen. Hvis problemet fortsætter, kontakt os på <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Noget gik galt',
        successDescription:
          'Gå tilbage til Vault App i Slack og autenticer med din nye adgangskode for at fortsætte, hvor du slap.',
        successHeading: 'Adgangskode er sat med succes',
      },
      noReports: {
        description:
          'Alle indsendte rapporter vil blive vist her. Lær mere om de måder, du kan indsende en rapport på i',
        descriptionHelpArticle: 'denne hjælpeartikel',
        errorDescription:
          'Vi har problemer med at indlæse dine rapporter. Prøv venligst at opdatere siden.',
        errorDescriptionSecondary:
          'Hvis det ikke virker, bedes du kontakte os på',
        errorTitle: '⚠️ Ups, noget er gået galt',
        title: 'Du har endnu ingen rapporter',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Aktivér automatisk oversættelse og læs alle rapportbeskeder på dit foretrukne sprog. Det oversatte sprog er baseret på det sprog, der er valgt på din enhed.',
          autoTranslationDescription2:
            'Du kan skifte mellem det oversatte og det oprindelige sprog i hver chat.',
          autoTranslationTitle:
            'Aktiver automatisk oversættelse for rapportmeddelelser',
          header: 'Beskedindstillinger',
          subHeader: 'Konfigurer hvordan beskeder vises',
        },
        notificationSettings: {
          emailDescription:
            'Modtag e-mail notifikationer for vigtige opdateringer til dine rapporter',
          emailTitle: 'Emailnotifikationer',
          header: 'Meddelelsesindstillinger',
          subHeader: 'Konfigurer, hvordan du modtager meddelelser',
        },
        title: 'Indstillinger',
        updatedSettingsFailure: 'Kunne ikke opdatere dine indstillinger',
        updatedSettingsSuccess:
          'Dine indstillinger er blevet opdateret succesfuldt.',
      },
    },
    validators: {
      passwordLength: 'Adgangskoden skal være mindst 9 tegn lang',
      passwordLowercase: 'Adgangskoden skal indeholde mindst 1 lille bogstav',
      passwordMissMatch:
        'Adgangskoden og bekræftelsesfelterne skal stemme overens.',
      passwordNumeric: 'Adgangskoden skal indeholde mindst 1 tal',
      passwordUppercase: 'Adgangskoden skal indeholde mindst 1 stort bogstav',
    },
    validatorsNew: {
      passwordLength: 'Mellem 10 og 30 tegn',
      passwordLowercase: 'Mindst ét lille bogstav',
      passwordMissMatch: 'Adgangskoder matcher ikke',
      passwordNumeric: 'Mindst ét tal',
      passwordSpecialCharacter: 'Mindst ét specialtegn',
      passwordUppercase: 'Mindst ét stort bogstav',
    },
  },
};

export default translations;
